// NOTE: NSAI-6812 — one key per main-navigation entry. The key names the
// destination, not a glyph: each platform resolves it to its own sidebar icon
// component (web: components/icons/navigation-icons.ts, mobile: the same path
// under apps/nsai/mobile/src/), so the sidebar and every surface that points
// at the same destination (the global search palette, …) show one icon.
export enum ENavigationIcon {
  NEW_CHAT = "new_chat",
  DASHBOARDS = "dashboards",
  CALL_ASSISTANT = "call_assistant",
  UPLOADS = "uploads",
  ASSISTANTS = "assistants",
  KNOWLEDGE = "knowledge",
  DOC_RECOGNITION = "doc_recognition",
  SKILLS = "skills",
  GENERATED_FILES = "generated_files",
  AGENTS = "agents",
  ANONYMIZATION_LAB = "anonymization_lab",
  PROMPT_LIBRARY = "prompt_library",
  MODELS = "models",
  ANALYTICS = "analytics",
  INTEGRATIONS = "integrations",
}
